import React, { useEffect, useState } from 'react'
import { Button, Spinner } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory, useLocation } from 'react-router-dom'

import packageJson from '../package.json'
import Layout from './Layout'
//components
import NavBar from './NavBar'
import OfficeNavbar from './PageComponents/OfficeSide/OfficeNavbar'
//utils
import { currentAuthenticatedUser } from './services/users'
import { getRatesAction } from './store/packageSlice'
import { setLoggedUserAction } from './store/userSlice'

export default function App() {
  const dispatch = useDispatch()
  const history = useHistory()
  const { loggedUser } = useSelector(state => state.user)
  const [isLoading, setisLoading] = useState(true)
  const location = useLocation()

  useEffect(() => {
    if (location.pathname.includes('v2')) {
      delete document.body.dataset.bs
      document.body.dataset.twp = ''
    } else {
      delete document.body.dataset.twp
      document.body.dataset.bs = ''
    }
  }, [location.pathname])
  useEffect(() => {
    //versioning
    const version = packageJson.version
    const last_version = localStorage.getItem(`version`)
    if (!last_version || last_version !== version) {
      localStorage.setItem(`version`, version)
      window.location.reload(true)
    }

    //affiliate
    const p = window.location.search
    if (p.includes('?ref')) {
      if (p.includes('&')) {
        localStorage.setItem('ref', p.slice(p.indexOf('?ref=') + 5, p.indexOf('&')))
      } else localStorage.setItem('ref', p.slice(p.indexOf('?ref=') + 5))
    }

    //user auth

    ;(async () => {
      const userData = await currentAuthenticatedUser()
      if (!userData) {
        localStorage.removeItem('cognito-tokens')
        setisLoading(false)
        return
      }
      let updatedPermission = {
        ...loggedUser.permissions,
      }
      userData.groups?.Groups.forEach(group => {
        updatedPermission = { ...updatedPermission, [group.GroupName]: true }
      })
      //update redux
      dispatch(
        setLoggedUserAction({
          ...userData,
          permissions: updatedPermission,
        })
      )
      dispatch(getRatesAction())
      if (history.location.pathname == '/') history.push('/personal-info')
      else history.push(history.location.pathname)

      setisLoading(false)
    })()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  // useEffect(() => {
  //   if (!loggedUser.Username || ENV === 'dev') return

  //   let inactivityTimeout

  //   const resetInactivityTimeout = () => {
  //     if (inactivityTimeout) clearTimeout(inactivityTimeout)
  //     inactivityTimeout = setTimeout(() => {
  //       localStorage.setItem('logout-reason', 'inactivity')
  //       localStorage.removeItem('cognito-tokens')
  //       window.location.href = '/welcome'
  //     }, 10 * 60 * 1000) // 10 minutes
  //   }

  //   const activityEvents = ['mousemove', 'keydown', 'click', 'touchstart', 'scroll', 'wheel', 'touchmove', 'touchend', 'touchcancel', 'mousedown']
  //   activityEvents.forEach((eventName) => {
  //     window.addEventListener(eventName, resetInactivityTimeout)
  //   })

  //   resetInactivityTimeout()

  //   return () => {
  //     if (inactivityTimeout) clearTimeout(inactivityTimeout)
  //     activityEvents.forEach((eventName) => {
  //       window.removeEventListener(eventName, resetInactivityTimeout)
  //     })
  //   }
  // }, [loggedUser])

  const hardRefresh = () => {
    localStorage.clear()
    history.push('/')
    window.location.reload(true)
  }

  return (
    <div className='rootContainer'>
      {isLoading ? (
        <div className='home-page-loading-cont' data-bs>
          <Spinner animation='border' variant='primary' />
          <div className='hpl-text'>טוען...</div>
          <div>
            <Button onClick={hardRefresh}> חזרה לעמוד הבית </Button>
          </div>
        </div>
      ) : (
        <>
          {loggedUser.permissions['Admin'] ||
          loggedUser.permissions['Agent'] ||
          loggedUser.permissions['SeniorAgent'] ||
          loggedUser.permissions['OfficeManager'] ||
          loggedUser.permissions['Worker'] ? (
            <OfficeNavbar></OfficeNavbar>
          ) : (
            <NavBar></NavBar>
          )}
          <Layout />
        </>
      )}
    </div>
  )
}
